<template>
    <div class="main">
        <div v-for="(item,idx) in picList" :key="idx">
            <img class="img" :src="item" />
        </div>
    </div>
</template>
<script>
import utils from "@/assets/js/utils";
import ajax from "@/api/cardAjax";
const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");
const courseId = utils.getQueryString("courseId");
export default {
    name:'picture_page',
    data(){
        return{
            picList:[
                "https://susuanqiniu.knowbox.cn/hellohuoxing-changtu.jpg"
            ]
        }
    },
    mounted(){
        this.getData();
    },
    methods: {
        async getData() {
            let resp = await ajax.get("/light/course/get-course-detail-img", {
                params: { token, version, source , courseId},
            });
            if (resp.config) resp = resp.data;
            if (resp.code == 99999) {
                this.picList = resp.data.courseDetail;
                console.log(this.picList);
            } else {
                this.$toast(resp.msg);
            }
        },
    }

    
}
</script>
<style lang="scss" scoped>
.main{
    .img{
        width: 100%;
    }
}
</style>
